import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import authReducer from "./authSlice";
import menuReducer from "./menuSlice";
import profilePostContentsPageViewReducer from "./profilePostContentsPageViewSlice";
import welcomePostReducer from "./welcomePostSlice";
import dashboardTopPost from "./dashboardTopposts";
import profileReducer from "./profileSlice";
import businessSuiteReducer from "./businessSuiteSlice";
import profileDetailReducer from "./profileDetailSlice";
import newFeedReducer from "./newFeedSlice";
import settingReducer from "./settingSlice";
import headerReducer from "./header";
import requestReducer from "./request";
import musicLibrariesReducer from "./musicLibraries";
import layoutReducer from "./layoutSlice";
import timeSheetReducer from "./timeSheet";
import toolReducer from "./toolStore";
import productReducer from "./productServicseStore";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    setting: settingReducer,
    header: headerReducer,
    request: requestReducer,
    layout: layoutReducer,
    menu: menuReducer,
    profilePostContentsPageView: profilePostContentsPageViewReducer,
    welcomePost: welcomePostReducer,
    topPosts: dashboardTopPost,
    profile: profileReducer,
    businessSuite: businessSuiteReducer,
    profileDetail: profileDetailReducer,
    newFeed: newFeedReducer,
    musicLibraries: musicLibrariesReducer,
    timeSheet: timeSheetReducer,
    tool: toolReducer,
    product: productReducer,
    // Add other reducers here if necessary
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
